(function () {
  'use strict';
  const root = document.querySelector('[data-b2b-portal]');
  if (!root) return;

  /* Concept 4: echte Shopify-producten (uit collectie sophie-me-b2b, via
     smg-live-products.liquid) en de bestaande demo-artikelen worden hier
     samengevoegd tot één lijst. Live producten staan voorop (de collectie
     zelf staat op "nieuwste eerst"; Amar kan dat in de Shopify admin zelf
     omzetten naar handmatig sorteren). Demo-artikelen blijven eronder
     zichtbaar totdat ze één voor één door echte producten worden vervangen. */
  const liveDataEl = document.getElementById('b2b-live-data');
  const demoDataEl = document.getElementById('b2b-demo-data');
  let liveData = [];
  try { liveData = liveDataEl ? JSON.parse(liveDataEl.textContent) : []; } catch { liveData = []; }
  const demoData = demoDataEl ? JSON.parse(demoDataEl.textContent) : [];
  const data = liveData;
  const article025Index = data.findIndex(product => product.article === 'SM-025');
  const article026Index = data.findIndex(product => product.article === 'SM-026');
  if (article025Index !== -1 && article026Index !== -1 && article025Index > article026Index) {
    [data[article025Index], data[article026Index]] = [data[article026Index], data[article025Index]];
  }
  const packDefinitions = {
    'SM-001': {count:6, sizes:{S:2, M:2, L:2}, ratio:'2×S · 2×M · 2×L'},
    'SM-002': {count:6, sizes:{'S/M':3, 'M/L':3}, ratio:'3×S/M · 3×M/L'},
    'SM-004': {count:10, sizes:{XS:1, S:3, M:3, L:2, XL:1}, ratio:'1×XS · 3×S · 3×M · 2×L · 1×XL'},
    'SM-007': {count:6, sizes:{S:2, M:2, L:2}, ratio:'2×S · 2×M · 2×L'},
    'SM-026': {count:6, sizes:{'S/M':3, 'M/L':3}, ratio:'3×S/M · 3×M/L'}
  };
  data.forEach(product => {
    const pack = packDefinitions[product.article];
    if (pack) {
      product.fixedPack = pack.count;
      product.packSizes = pack.sizes;
      product.ratio = pack.ratio;
      product.description = ({ 'SM-001':'Getailleerde cropped pufferjas met capuchon.', 'SM-002':'Lange pufferjas met capuchon en een comfortabele, ruimvallende pasvorm.', 'SM-004':'Barrel jeans met een gerafelde zoom.', 'SM-007':'Zwarte PU short met studs.', 'SM-026':'Fijngebreid vest met ronde hals, lange mouwen en zeven goudkleurige hartjesknopen. De golvende afwerking aan de zoom en mouwranden geeft het vest een verfijnd detail.' }[product.article]) + ' Uitsluitend per pakket van ' + pack.count + ' stuks: ' + pack.ratio + '. Geen losse stuks.';
    }
  });

  const byId = id => document.getElementById(id);
  const palette = {'Aubergine':'#452039','Gebroken':'#eee5d4','Marine':'#101c32','Taupe':'#b0a49f','Paars':'#58203f','Blauw':'#658ab5','Crème':'#e8ddc5','Bordeaux':'#6c2934','Zwart':'#24201c','Ruit':'#a69b87','Bruin':'#493027','Rood':'#8c2a2a','Uni':'#c7bba6'};
  const swatch = color => palette[color.split(' ')[0]] || '#c7bba6';
  const money = value => new Intl.NumberFormat('nl-NL', {style:'currency', currency:'EUR'}).format(value);
  const choices = {};
  const cards = new Map();
  let current;
  let filterTimer;
  let displayedView = null;
  let routeRevision = 0;
  let restoringCatalog = false;
  let lastProductId = '';
  const catalogKey = 'smg-catalog-position-v1:' + window.location.pathname + ':' + (new URL(window.location.href).searchParams.get('preview_theme_id') || 'live');
  let catalogPosition = null;
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(catalogKey));
    if (saved && Number.isFinite(saved.top) && saved.top >= 0 && typeof saved.query === 'string') catalogPosition = saved;
  } catch {}
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  function rememberCatalog(articleId, useSavedTop = false) {
    if (displayedView !== 'catalog' || restoringCatalog) return;
    const top = useSavedTop && catalogPosition ? catalogPosition.top : window.scrollY;
    const id = articleId || (catalogPosition && catalogPosition.articleId) || '';
    const card = cards.get(String(id));
    catalogPosition = {
      top,
      articleId: id,
      offset: card && !card.hidden ? card.getBoundingClientRect().top + window.scrollY - top : null,
      query: byId('b2b-search').value
    };
    try { window.sessionStorage.setItem(catalogKey, JSON.stringify(catalogPosition)); } catch {}
  }

  function restoreCatalog(fallbackId, revision) {
    restoringCatalog = true;
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (revision !== routeRevision || displayedView !== 'catalog') return;
      const saved = catalogPosition && catalogPosition.query === byId('b2b-search').value ? catalogPosition : null;
      const id = saved && saved.articleId || fallbackId;
      const card = cards.get(String(id));
      let top = saved ? saved.top : 0;
      if (card && !card.hidden) {
        const header = document.querySelector('[data-smg-header]');
        const offset = saved && Number.isFinite(saved.offset) ? saved.offset : (header ? header.getBoundingClientRect().height : 0) + 24;
        top = card.getBoundingClientRect().top + window.scrollY - offset;
        const link = card.querySelector('a');
        if (link) link.focus({preventScroll:true});
      }
      window.scrollTo({top:Math.max(0, top), behavior:'instant'});
      restoringCatalog = false;
      rememberCatalog(id);
    }));
  }

  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function appendSwatch(parent, color) {
    const dot = node('span', 'b2b-swatch');
    dot.style.setProperty('--swatch', swatch(color));
    dot.title = color;
    parent.append(dot);
  }

  function addPrice(parent, product) {
    const priceValue = Number(product.price);
    if (!priceValue) return;
    parent.append(node('p', 'b2b-card-price', money(product.fixedPack ? priceValue * product.fixedPack : priceValue) + (product.fixedPack ? ' per pakket excl. btw' : ' excl. btw')));
  }

  function buildCards() {
    const fragment = document.createDocumentFragment();
    data.forEach(product => {
      const article = node('article', 'b2b-card');
      article.dataset.search = [product.name, product.article, product.category, product.colors.join(' ')].join(' ').toLocaleLowerCase('nl');

      const photoLink = node('a', 'b2b-card-photo');
      photoLink.href = '#artikel/' + product.id;
      photoLink.setAttribute('aria-label', 'Bekijk ' + product.name);
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.name;
      image.width = 1122;
      image.height = 1402;
      image.loading = 'lazy';
      photoLink.append(image);
      if (product.status) photoLink.append(node('span', 'b2b-badge', product.status));

      const copy = node('div', 'b2b-card-copy');
      copy.append(node('p', 'b2b-sku', product.article), node('h2', '', product.name));
      if (product.colors[0] !== 'Uni') {
        const colorDots = node('div', 'b2b-card-swatches');
        colorDots.setAttribute('aria-label', 'Kleuren: ' + product.colors.join(', '));
        product.colors.forEach(color => appendSwatch(colorDots, color));
        copy.append(colorDots, node('p', '', product.colors.join(' · ')));
      }
      copy.append(node('p', '', product.sizes.map(size => size.label).join(' · ')));
      addPrice(copy, product);
      const detailLink = node('a', 'smg-text-link');
      detailLink.href = '#artikel/' + product.id;
      detailLink.append(document.createTextNode('Bekijk artikel '), node('span', '', '→'));
      detailLink.lastElementChild.setAttribute('aria-hidden', 'true');
      copy.append(detailLink);
      article.append(photoLink, copy);
      fragment.append(article);
      cards.set(String(product.id), article);
    });
    byId('b2b-grid').replaceChildren(fragment);
  }

  function applyFilter() {
    const query = byId('b2b-search').value.trim().toLocaleLowerCase('nl');
    let visible = 0;
    data.forEach(product => {
      const show = !query || cards.get(String(product.id)).dataset.search.includes(query);
      cards.get(String(product.id)).hidden = !show;
      if (show) visible += 1;
    });
    byId('b2b-count').textContent = visible + ' artikel' + (visible === 1 ? '' : 'en');
    byId('b2b-empty').hidden = visible > 0;
    const url = new URL(window.location.href);
    if (query) url.searchParams.set('q', byId('b2b-search').value.trim());
    else url.searchParams.delete('q');
    history.replaceState(null, '', url);
  }

  function configureCarousel() {
    const hero = root.querySelector('.b2b-wide-banner');
    if (!hero) return;
    const slides = [...hero.querySelectorAll('.b2b-banner-slide')];
    const dots = [...hero.querySelectorAll('[data-slide]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let slide = 0;

    function showSlide(index) {
      slide = index;
      slides.forEach((item, position) => {
        item.classList.toggle('is-active', position === slide);
        item.setAttribute('aria-hidden', String(position !== slide));
      });
      dots.forEach((dot, position) => {
        dot.classList.toggle('is-active', position === slide);
        dot.setAttribute('aria-pressed', String(position === slide));
      });
    }

    dots.forEach(dot => dot.addEventListener('click', () => showSlide(Number(dot.dataset.slide))));
    window.setInterval(() => {
      if (reducedMotion.matches || document.hidden || byId('b2b-collection').hidden) return;
      const next = (slide + 1) % slides.length;
      const nextImage = slides[next].querySelector('img');
      if (nextImage.complete && nextImage.naturalWidth) showSlide(next);
    }, 5500);
  }

  function state() {
    return choices[current.id];
  }

  function total() {
    return Object.values(state().sizes).reduce((sum, quantity) => sum + quantity, 0);
  }

  function syncTotal() {
    const quantity = total();
    byId('b2b-total').textContent = current.fixedPack
      ? (quantity / current.fixedPack) + (quantity === current.fixedPack ? ' pakket' : ' pakketten') + ' · ' + quantity + ' stuks'
      : quantity + ' stuks';
    byId('b2b-error').textContent = '';
  }

  function renderPrice() {
    const priceValue = Number(current.price);
    byId('b2b-price-block').hidden = !priceValue;
    if (priceValue) byId('b2b-wholesale-price').textContent = current.fixedPack ? money(priceValue * current.fixedPack) + ' per pakket (' + money(priceValue) + ' per stuk)' : money(priceValue);
  }

  function renderFacts() {
    const facts = [
      ['Materiaal', current.material],
      ['Pasvorm', current.fit],
      ['Ratiopak', current.ratio],
      ['Minimale afname', current.minimum ? current.minimum + ' stuks' : null]
    ].filter(([, value]) => value);
    const fragment = document.createDocumentFragment();
    facts.forEach(([label, value]) => {
      const row = node('div');
      row.append(node('dt', '', label), node('dd', '', typeof value === 'string' ? value : JSON.stringify(value)));
      fragment.append(row);
    });
    byId('b2b-facts').replaceChildren(fragment);
    byId('b2b-product-facts').hidden = facts.length === 0;
  }

  function renderRules() {
    const rules = [];
    if (current.fixedPack) {
      byId('b2b-order-rule').textContent = 'Alleen per pakket van ' + current.fixedPack + ' stuks · ' + current.ratio + ' · Geen losse stuks';
      byId('b2b-order-rule').hidden = false;
      return;
    }
    if (current.minimum) rules.push('Minimale afname: ' + current.minimum + ' stuks');
    if (current.packMultiple) rules.push('Bestellen per ' + current.packMultiple + ' stuks');
    if (current.ratio && typeof current.ratio === 'string') rules.push('Maatverdeling: ' + current.ratio);
    byId('b2b-order-rule').textContent = rules.join(' · ');
    byId('b2b-order-rule').hidden = rules.length === 0;
  }

  function currentColorImage() {
    if (current.colorImages && current.colorImages[state().color]) return current.colorImages[state().color];
    return current.image;
  }

  function currentBackImage() {
    if (current.colorBackImages && current.colorBackImages[state().color]) return current.colorBackImages[state().color];
    return current.backImage;
  }

  function currentVariants() {
    if (!Array.isArray(current.variants)) return [];
    return current.variants.filter(variant => variant.color === state().color);
  }

  function syncVariantSelection() {
    const selectedVariant = currentVariants()[0];
    state().variantId = selectedVariant ? String(selectedVariant.id) : '';
    root.dataset.selectedVariantId = state().variantId;
    byId('b2b-colors').querySelectorAll('input[name="color"]').forEach(input => {
      input.checked = input.value === state().color;
    });
    byId('b2b-color-thumbnails').querySelectorAll('[data-color]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.color === state().color));
    });
  }

  function renderGallery() {
    const frontImage = currentColorImage();
    const backImage = currentBackImage();
    byId('b2b-photo').src = frontImage;
    byId('b2b-photo').alt = current.name + ' · ' + current.article + ' · ' + state().color + ' · voorkant';

    const photos = [
      {src:frontImage, label:'Voorkant'},
      {src:backImage, label:'Achterkant'}
    ];
    const extraImage = current.colorExtraImages && current.colorExtraImages[state().color]
      ? current.colorExtraImages[state().color]
      : (current.colors.length === 1 ? current.extraImage : null);
    if (extraImage) photos.push({src:extraImage, label:'Detail'});

    const availablePhotos = photos.filter(photo => photo.src);
    const photoFragment = document.createDocumentFragment();
    availablePhotos.forEach((photo, index) => {
      const button = node('button');
      button.type = 'button';
      button.dataset.photo = photo.src;
      button.dataset.label = photo.label;
      button.setAttribute('aria-label', state().color + ' · ' + photo.label.toLocaleLowerCase('nl') + ' bekijken');
      button.setAttribute('aria-pressed', String(index === 0));
      const image = document.createElement('img');
      image.src = photo.src;
      image.alt = '';
      image.width = 70;
      image.height = 88;
      button.append(image);
      photoFragment.append(button);
    });
    byId('b2b-thumbs').replaceChildren(photoFragment);
    byId('b2b-thumbs').hidden = availablePhotos.length < 2;
    byId('b2b-gallery-help').hidden = availablePhotos.length < 2;
  }

  function renderColorSelectors() {
    byId('b2b-colors').replaceChildren();

    const thumbnailFragment = document.createDocumentFragment();
    const singleColor = current.colors.length === 1;
    const thumbnailContainer = byId('b2b-color-thumbnails');
    thumbnailContainer.hidden = singleColor;
    if (singleColor) byId('b2b-colors').append(node('span', 'b2b-single-color', current.colors[0]));
    (singleColor ? [] : current.colors).forEach(color => {
      const button = node('button', 'b2b-color-thumbnail');
      button.type = 'button';
      button.dataset.color = color;
      const matchingVariant = Array.isArray(current.variants) ? current.variants.find(variant => variant.color === color) : null;
      if (matchingVariant) button.dataset.variantId = matchingVariant.id;
      button.setAttribute('aria-label', 'Kleur ' + color + ' selecteren');
      button.setAttribute('aria-pressed', String(color === state().color));
      const image = document.createElement('img');
      image.src = current.colorImages && current.colorImages[color] ? current.colorImages[color] : current.image;
      image.alt = '';
      image.width = 112;
      image.height = 140;
      image.loading = 'lazy';
      button.append(image, node('span', '', color));
      thumbnailFragment.append(button);
    });
    byId('b2b-color-thumbnails').replaceChildren(thumbnailFragment);
    byId('b2b-colors').closest('fieldset').hidden = current.colors[0] === 'Uni';
    syncVariantSelection();
  }

  function scrollToSelectedPhoto() {
    if (!window.matchMedia('(max-width: 800px)').matches) return;
    const photo = byId('b2b-photo');
    const frame = photo && photo.closest('.b2b-main-photo');
    if (!frame) return;
    window.requestAnimationFrame(() => {
      const header = document.querySelector('[data-smg-header]');
      let offset = 12;
      if (header) {
        const style = window.getComputedStyle(header);
        if (style.position === 'sticky' || style.position === 'fixed') {
          offset += header.getBoundingClientRect().height + Math.max(0, parseFloat(style.top) || 0);
        }
      }
      const top = Math.max(0, frame.getBoundingClientRect().top + window.scrollY - offset);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top, behavior: reducedMotion ? 'instant' : 'smooth'});
    });
  }

  function selectColor(color) {
    if (!current.colors.includes(color)) return;
    state().color = color;
    syncVariantSelection();
    renderGallery();
    syncTotal();
  }

  function renderProduct() {
    byId('b2b-title').textContent = current.name;
    byId('b2b-sku').textContent = 'Artikelnummer ' + current.article;
    const productBadge = byId('b2b-badge');
    productBadge.textContent = current.status;
    productBadge.hidden = !current.status;
    byId('b2b-description').textContent = current.description || 'Een artikel uit de collectie van Sophie & Me.';
    renderColorSelectors();
    renderGallery();

    const sizeFragment = document.createDocumentFragment();
    const orderSizes = current.fixedPack ? [{label:'Pakketten (' + current.fixedPack + ' stuks: ' + current.ratio + ')'}] : current.sizes;
    orderSizes.forEach((size, index) => {
      const row = node('div', 'b2b-size-row');
      const label = node('label', '', size.label);
      label.htmlFor = 'b2b-size-' + index;
      const input = document.createElement('input');
      input.id = 'b2b-size-' + index;
      input.dataset.size = current.fixedPack ? '__pack' : size.label;
      input.setAttribute('aria-label', current.fixedPack ? 'Aantal pakketten van ' + current.fixedPack + ' stuks' : 'Aantal maat ' + size.label);
      input.type = 'number';
      input.min = '0';
      input.max = current.fixedPack ? String(Math.floor(999 / Math.max(...Object.values(current.packSizes)))) : '999';
      input.step = '1';
      input.inputMode = 'numeric';
      input.value = current.fixedPack ? total() / current.fixedPack : state().sizes[size.label];
      input.disabled = current.status === 'Uitverkocht';
      row.append(label, input);
      sizeFragment.append(row);
    });
    byId('b2b-sizes').replaceChildren(sizeFragment);
    const addCartButton = byId('b2b-add-cart');
    if (addCartButton) {
      addCartButton.disabled = current.status === 'Uitverkocht';
      addCartButton.textContent = current.status === 'Uitverkocht' ? 'Uitverkocht' : 'Toevoegen aan winkelwagen';
      byId('b2b-add-status').textContent = '';
    }
    renderPrice();
    renderFacts();
    renderRules();
    syncTotal();
  }

  function route() {
    const previousView = displayedView;
    const revision = ++routeRevision;
    restoringCatalog = false;
    const cartOpen = location.hash === '#winkelwagen' || location.hash === '#bestelling-ontvangen';
    const id = location.hash.startsWith('#artikel/') ? location.hash.slice(9) : '';
    if (previousView === 'catalog' && id) rememberCatalog(id, true);
    current = data.find(product => String(product.id) === id);
    displayedView = cartOpen ? 'cart' : current ? 'product' : 'catalog';
    const cartView = byId('smg-cart-view');
    if (cartView) cartView.hidden = !cartOpen;
    byId('b2b-collection').hidden = cartOpen || Boolean(current);
    byId('b2b-product').hidden = cartOpen || !current;
    if (cartOpen) {
      document.dispatchEvent(new CustomEvent('smg:cart-open'));
      window.scrollTo({top:0, behavior:'instant'});
      return;
    }
    if (!current) {
      applyFilter();
      if (previousView === 'product' || previousView === 'cart' || (previousView === null && location.hash === '#b2b-collection' && catalogPosition)) restoreCatalog(lastProductId, revision);
      else if (location.hash === '#b2b-collection') byId('b2b-collection').scrollIntoView();
      return;
    }
    lastProductId = id;
    if (!choices[id]) {
      choices[id] = {color:current.colors[0], sizes:Object.fromEntries(current.sizes.map(size => [size.label, 0]))};
    }
    renderProduct();
    window.scrollTo({top:0, behavior:'instant'});
    byId('b2b-title').focus({preventScroll:true});
  }

  function validateOrder() {
    const quantity = total();
    if (current.fixedPack) {
      const packs = Object.entries(current.packSizes).map(([size, count]) => (state().sizes[size] || 0) / count);
      if (quantity < current.fixedPack || !Object.keys(state().sizes).every(size => size in current.packSizes)
        || !packs.every(value => Number.isInteger(value) && value > 0 && value === packs[0])) {
        return 'Kies een heel aantal pakketten van ' + current.fixedPack + ' stuks (' + current.ratio + ').';
      }
    }
    if (quantity < 1) return 'Vul bij minimaal één maat een aantal in.';
    if (current.minimum && quantity < current.minimum) return 'De minimale afname is ' + current.minimum + ' stuks.';
    if (current.packMultiple && quantity % current.packMultiple !== 0) return 'Bestel een veelvoud van ' + current.packMultiple + ' stuks.';
    return '';
  }

  function setupCartButton() {
    const status = node('p', 'b2b-fine', '');
    status.id = 'b2b-add-status';
    status.setAttribute('role', 'status');

    const addButton = node('button', 'smg-button smg-button--dark b2b-full', 'Toevoegen aan winkelwagen');
    addButton.type = 'submit';
    addButton.id = 'b2b-add-cart';

    byId('b2b-order').append(status, addButton);

    return status;
  }

  configureCarousel();
  buildCards();
  const addStatus = setupCartButton();
  const initialQuery = new URL(window.location.href).searchParams.get('q') || '';
  byId('b2b-search').value = initialQuery;

  root.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    event.preventDefault();
    const hash = link.getAttribute('href');
    if (displayedView === 'catalog') rememberCatalog(hash.startsWith('#artikel/') ? hash.slice(9) : '');
    if (location.hash === hash) route();
    else location.hash = hash;
  });
  byId('b2b-search').addEventListener('input', () => {
    window.clearTimeout(filterTimer);
    filterTimer = window.setTimeout(applyFilter, 120);
  });
  root.querySelector('.b2b-filters').addEventListener('reset', () => window.setTimeout(applyFilter, 0));
  byId('b2b-colors').addEventListener('change', event => {
    if (event.target.name === 'color') {
      selectColor(event.target.value);
    }
  });
  byId('b2b-color-thumbnails').addEventListener('click', event => {
    const button = event.target.closest('[data-color]');
    if (button) {
      selectColor(button.dataset.color);
      scrollToSelectedPhoto();
    }
  });
  byId('b2b-thumbs').addEventListener('click', event => {
    const button = event.target.closest('[data-photo]');
    if (!button) return;
    byId('b2b-photo').src = button.dataset.photo;
    byId('b2b-photo').alt = current.name + ' · ' + current.article + ' · ' + state().color + ' · ' + button.dataset.label.toLocaleLowerCase('nl');
    byId('b2b-thumbs').querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
  byId('b2b-sizes').addEventListener('input', event => {
    if (!event.target.dataset.size) return;
    const quantity = Number(event.target.value);
    if (Number.isInteger(quantity) && quantity >= 0 && quantity <= Number(event.target.max)) {
      if (current.fixedPack && event.target.dataset.size === '__pack') {
        Object.entries(current.packSizes).forEach(([size, count]) => { state().sizes[size] = quantity * count; });
      } else {
        state().sizes[event.target.dataset.size] = quantity;
      }
    }
    syncTotal();
  });
  byId('b2b-order').addEventListener('submit', event => {
    event.preventDefault();
    if (!current || current.status === 'Uitverkocht' || !event.target.reportValidity()) return;
    const error = validateOrder();
    if (error) {
      byId('b2b-error').textContent = error;
      addStatus.textContent = '';
      return;
    }
    const sizes = {};
    const variantIds = {};
    const variantSkus = {};
    Object.entries(state().sizes).forEach(([size, quantity]) => {
      if (quantity > 0) {
        sizes[size] = quantity;
        const variant = currentVariants().find(item => item.size === size);
        if (variant) {
          variantIds[size] = variant.id;
          variantSkus[size] = variant.sku || current.article;
        }
      }
    });
    document.dispatchEvent(new CustomEvent('smg:add-to-cart', {detail:{
      id: current.id,
      article: current.article,
      name: current.name,
      color: state().color,
      variantId: state().variantId || null,
      variantIds: variantIds,
      variantSkus: variantSkus,
      image: currentColorImage(),
      price: current.price || null,
      sizes: sizes,
      total: total()
    }}));
    current.sizes.forEach(size => { state().sizes[size.label] = 0; });
    renderProduct();
    addStatus.textContent = 'Toegevoegd aan je winkelwagen.';
  });
  window.addEventListener('scroll', () => {
    if (displayedView === 'catalog' && !location.hash.startsWith('#artikel/') && location.hash !== '#winkelwagen' && location.hash !== '#bestelling-ontvangen') rememberCatalog();
  }, {passive:true});
  window.addEventListener('pagehide', () => rememberCatalog());
  window.addEventListener('hashchange', route);
  route();
})();
